import * as fxjs from 'fxjs/es';

export const html: (templateStrs: TemplateStringsArray, ...templateVals: unknown[]) => string = fxjs.html;
